import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';
import Button from 'Components/Atoms/Button/Button';
import Container from 'Components/Atoms/Container/Container';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import Title from 'Components/Atoms/Title/Title';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import DeletionModal from 'Components/Molecules/Modals/Actions/DeletionModal/DeletionModal';
import Modal from 'Components/Molecules/Modals/Modal/Modal';
import ModalFooter from 'Components/Molecules/Modals/ModalFooter/ModalFooter';
import ModalHeader from 'Components/Molecules/Modals/ModalHeader/ModalHeader';
import TableCell from 'Components/Molecules/TableCell/TableCell';
import TableRow from 'Components/Molecules/TableRow/TableRow';
import Field from 'Components/Organisms/Field/Field';
import { useState } from 'react';
import { connect } from 'react-redux';
import { MODULES } from 'Services/Settings/Modules/Helper';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { patchModule } from 'Store/Settings/Modules/Actions';
import { getModulesByEntityIdByModule } from 'Store/Settings/Modules/Selectors';

const ContactModuleItem = ({
    id, name, entity_id,

    modulesByEntityIdByModule,

    ...props
}: ContactModuleItemProps) => {
    const [data, setData] = useState({ id, name });
    const [state, setState] = useState({
        isEdit: false,
        isValid: true,
        showDeleteConfirmation: false
    });

    const handleEdit = () => {
        if (state.isEdit) setData({ id, name });

        setState((state) => ({
            ...state,
            isEdit: !state.isEdit
        }));
    }

    const handleChange = (value: string) => {
        setState((state) => ({
            ...state,
            isValid: value?.length > 0
        }));

        setData((state) => ({
            ...state,
            name: value
        }));
    }

    const handleSave = () => {
        const record = modulesByEntityIdByModule?.[entity_id]?.[MODULES.CONTACT];
        const newLabels = [...(record?.configuration?.labels ?? [])];
        console.log('NEW LABELS: ', newLabels);

        const idx = newLabels.findIndex(i => i.id === id);

        newLabels[idx].name = data?.name;

        props.patchModule(record?.id, {
            configuration: {
                ...record?.configuration,
                labels: newLabels
            }
        });
        handleEdit();
    }

    const handleDelete = () => {
        setState((state) => ({
            ...state,
            showDeleteConfirmation: true
        }));
    }

    const processDelete = () => {
        const record = modulesByEntityIdByModule?.[entity_id]?.[MODULES.CONTACT];

        const newLabels = record?.configuration?.labels?.filter(i => i.id !== id);

        props.patchModule(record?.id, {
            configuration: {
                ...record?.configuration,
                labels: newLabels
            }
        });
    }

    return <>
        {
            state.showDeleteConfirmation
            && <DeletionModal
                onClose={() => setState({
                    ...state,
                    showDeleteConfirmation: false
                })}
                onDelete={processDelete}
                // isDeleting={isDeleting}
            >
                { name } zal worden verwijderd bla bla bla, niet te herstellen bla bla la,
            </DeletionModal>
        }
        {
            state.isEdit
            && <Modal size='small'>
                <ModalHeader size='small'>
                    <Title
                        size='medium'
                        weight='bold'
                    >
                        { name } aanpassen
                    </Title>
                </ModalHeader>
        
                <Container padding='vertical'>
                    <FormGroup title='Naam'>
                        <Field
                            isEdit={true}
                            value={data.name}
                            onChange={handleChange}
                            // value={data.values?.[i]?.value ?? values?.[i]?.value}
                            // onChange={(value: any) => handleValueChange(i, value)}
                            type={FieldType.Text}
                        />
                    </FormGroup>
                </Container>
        
                <ModalFooter size='small'>
                    <ButtonGroup>
                        {/* { !isPatching && */}
                            <Button
                                variant="transparent"
                                onClick={handleEdit}
                            >
                                Annuleren
                            </Button>
                        {/* } */}
                        <Button
                            color="primary"
                            variant="solid"
                            onClick={handleSave}
                            isDisabled={!state.isValid}
                            // isLoading={isPatching}
                        >
                            Opslaan
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        }
        <TableRow>
            <TableCell primary>
                { name }
            </TableCell>
            <Button
                variant='transparent'
                color='light'
                size='medium'
                iconBefore={<FontAwesomeIcon icon={faPencil} />}
                onClick={handleEdit}
            />
            <Button
                variant='transparent'
                color='light'
                size='medium'
                iconBefore={<FontAwesomeIcon icon={faTrash} />}
                onClick={handleDelete}
            />
        </TableRow>
    </>;
}

interface Props {
    id: any
    name: any
    entity_id: any
}

const mapState = (state: StoreState, props: Props) => ({
    modulesByEntityIdByModule: getModulesByEntityIdByModule(state),
});

const mapDispatch = {
    patchModule
};

type ContactModuleItemProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(ContactModuleItem);